module.exports = "<div class=\"loader-container\">\n  <p class=\"m-b-0\">Loading Workshop...</p>\n  <div class=\"loader\"></div>\n</div>\n"